import LocalStorage from '@/../bower_components/teknisavuecomponents/assets/localStorage/localStorage';
import store from '@/store/store';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import UtilPG from '@/assets/ts/utils/Util';
import { RouterController } from '@/Router';
import UserRepository from '../offline/repository/UserRepository';
//import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import { EstruturasOffline, PeriodoOffline, UserOffline } from '../interfaces/Offline';
import EstruturaRepository from '@/assets/ts/offline/repository/EstruturaRepository';
import PeriodoRepository from '@/assets/ts/offline/repository/PeriodoRepository';
import VinculoRepository from '@/assets/ts/offline/repository/VinculoRepository';
import OfflineController from '@/assets/ts/controller/OfflineController';
import LocalizacaoController from '@/assets/ts/controller/LocalizacaoController';
import DynamicRepository from '@/assets/ts/offline/repository/DynamicRepository';
import { OfflineTablesName } from '@/assets/ts/offline/DynamicTables';

export default class Environment {

  private static get isMobile() {
    return OfflineController.isMobile();
  }

  public static async loadInfoIntoStore(): Promise<void> {
    try {
      store.commit('setLoadingVisibility', true);

      if(OfflineController.checkIsOffline()) {
        await this.storeOffline();
        return;
      }

      await this.loadUserInfo();

      // Caso já tenha cache deixa o carregamento em segundo plano (sem await)
      const hasCache = await OfflineController.hasCachedData();
      
      if(this.isMobile && hasCache) {
        await this.storeOffline();
        this.loadSystemInfo();
      } else {
        await this.loadSystemInfo();
      }

      if (this.isMobile) {
        this.loadVinculosForOffline();
      }

    } catch(err) {
      throw err;
    } finally {
      store.commit('setLoadingVisibility', false);
      store.commit('updateFinishedLoadingInfo', true);

      RouterController.updateRoutes();
    }
  }

  private static async loadUserInfo(): Promise<void> {
    const localStorage = new LocalStorage();

    await this.getLoginInfo();

    let userData = localStorage.getItems([
      'USER_NAME',
      'USER_ID',
      'EMAIL',
      'NMRAZSOCESTRUT',
      'NMESCALATRABH',
      'NRVINCULOM',
      'NRVINCULOM',
      'NRTIPOVINCULOM',
      'USER_ID',
      'NMOPERADOR',
      'NRORG',
      'dp',
      'NRESTRUTLEGAL',
      'NRESTRUTGEREN',
      'IDALTERPTOVINCULO',
      'IDAPROVOCORRENCIA',
      'IDALTRESUMOFREQ',
      'IDTROCAHORARIO',
      'IDCONFIRMRECSENPORT',
      'IDREALIZAADMISSAO',
      'IDREALIZACADAUTOM',
      'IDDPALTERPTOVINCULO',
      'NRPARCNEGOCIO',
      'IDPGRESTRINGEREGIST',
      'IDPGRESTRINGETELAREGIST',
      'IDBLOQUEIOEDICAOMARC',
      'IDEXIGEFOTOREGPNTPG',
      'IDPGRESTRINGETELAREGIST',
      'NRTPESTRUTLEGAL',
      'NRTPESTRUTGEREN',
      'IDATIVACONTROLEACESSO',
      'ID_OPERADOR_SST'
    ]);

    userData = Util.arrayReplace(userData, 'null', null);

    const isDP = userData.dp === 'true';

    store.commit('updateUser', {
      name: userData.USER_NAME,
      id: userData.USER_ID,
      email: userData.EMAIL,
      team: userData.NMRAZSOCESTRUT,
      shift: userData.NMESCALATRABH,
      nrvinculom: userData.NRVINCULOM,
      nrtipovinculom: userData.NRTIPOVINCULOM,
      cdoperador: userData.USER_ID,
      nmoperador: userData.NMOPERADOR,
      nrorg: userData.NRORG,
      dp: isDP,
      nrestrutlegal: userData.NRESTRUTLEGAL,
      nrestrutgeren: userData.NRESTRUTGEREN,
      idalterptovinculo: userData.IDALTERPTOVINCULO,
      idaprovocorrencia: userData.IDAPROVOCORRENCIA,
      idaltresumofreq: userData.IDALTRESUMOFREQ,
      idtrocahorario: userData.IDTROCAHORARIO,
      idconfirmrecsenport: userData.IDCONFIRMRECSENPORT,
      idrealizaadmissao: isDP ? UtilPG.ID_TRUE : userData.IDREALIZAADMISSAO,
      idrealizacadautom: userData.IDREALIZACADAUTOM == UtilPG.ID_TRUE,
      iddpalterptovinculo: userData.IDDPALTERPTOVINCULO == UtilPG.ID_TRUE,
      nrparcnegocio: userData.NRPARCNEGOCIO,
      idpgrestringeregist: userData.IDPGRESTRINGEREGIST == UtilPG.ID_TRUE,
      idpgrestringetelaregist: userData.IDPGRESTRINGETELAREGIST == UtilPG.ID_TRUE,
      idbloqueioedicaomarc: userData.IDBLOQUEIOEDICAOMARC == UtilPG.ID_TRUE,
      idexigefotoregpntpg: userData.IDEXIGEFOTOREGPNTPG == UtilPG.ID_TRUE,
      nrtpestrutlegal: userData.NRTPESTRUTLEGAL,
      nrtpestrutgeren: userData.NRTPESTRUTGEREN,
      idativacontroleacesso: userData.IDATIVACONTROLEACESSO == UtilPG.ID_TRUE,
      idoperadorsst: userData.ID_OPERADOR_SST == UtilPG.ID_TRUE,
    });

    this.loadPermissoes();

  }

  public static async getLoginInfo(): Promise<void> {
    const localStorage = new LocalStorage();
    const cdOperador = window.localStorage.getItem('USER_ID');

    try {
      const response = await HttpRequest.get('validaLoginOperador', {
        requestType: 'FilterData',
        CDOPERADOR: cdOperador,
      }, false);

      if (typeof response.data === 'string') {
        throw response.data;
      }

      const loginInfo = response.data.dataset.validaLoginOperador[0];

      await this.setUserOffline(loginInfo);

      if (loginInfo.LOGIN_VALIDO) {
        localStorage.setItemsFromObject(loginInfo);
        this.setPermissoes(loginInfo.PERMISSOES);
      } else {
        throw 'Usuário sem permissão de acesso ao sistema.';
      }
    } catch(err) {

      if(this.isMobile) {
        this.updateUserOffline();
        return;
      }

      const errorMessage = typeof err === 'string' ?
        err :
        err.response.data.error;

      throw new Error(errorMessage);
    }
  }

  private static async loadSystemInfo(): Promise<void> {
    try {
      const periodoPromise = this.loadPeriodo();
      const estruturasPromise = this.loadEstruturas();

      const promises = [
        periodoPromise,
        estruturasPromise
      ];

      await Promise.all(promises); 

    } catch (err) {
      throw new Error('Não foi possível carregar as informações do sistema.');
    }
  }

  private static async loadPeriodo(): Promise<void> {
    try {
      const route = 'getPeriodosDemonstrativo';
      const nrorg = store.getters.user.nrorg;

      const params = {
        requestType: 'FilterData',
        NRORG: nrorg,
      };

      const response = await HttpRequest.get(route, params, false);
      const periodos = response.data.dataset.data;

      await this.setPeriodoOffline(periodos);

      // O período atual é definido no final desse commit
      store.commit('updatePeriodosDemonstrativo', periodos);
    } catch (err) {

      if(this.isMobile) {
        this.updatePeriodoOffline();
        return;
      }

      throw 'Não foi possível obter as informações de período.';
    }
  }

  private static async loadEstruturas() : Promise<void> {
    try {
      const route = 'getEstruturasGerenciais';
      const nrorg = store.getters.user.nrorg;
      const cdOperador = store.getters.user.cdoperador;

      const params = {
        requestType: 'FilterData',
        NRORG: nrorg,
        CDOPERADOR: cdOperador,
      };

      const response = await HttpRequest.get(route, params, false);
      const estruturas = response.data.dataset.data;

      await this.setEstruturasOffline(estruturas);

      store.commit('updateEstruturasGerenciais', estruturas);
    } catch(err) {

      if(this.isMobile) {
        await this.updateEstruturasOffline();
        return;
      }

      throw 'Não foi possível obter as estruturas gerenciais.';
    }
  }

  private static setPermissoes(permissoes: any) {
    try {

      if(!permissoes) {
        localStorage.removeItem('PERMISSOES');
        return;
      } 

      localStorage.setItem('PERMISSOES', JSON.stringify(permissoes));
    } catch (error) {
      console.log('Ocorreu um erro ao salvar as Permissões');
    }
  }

  private static loadPermissoes() {
    try {
      const localStorage = new LocalStorage();
      let permissoes = localStorage.getItem('PERMISSOES');
    
      if (!permissoes) return;

      permissoes = JSON.parse(permissoes);
    
      store.commit('updatePermissoes', permissoes);
  
    } catch (error) {
      console.log('Ocorreu um erro ao buscar as Permissões');
    }
  }

  // OFFLINE

  private static async loadVinculosForOffline() : Promise<void> {
    try {
      const route = 'getVinculosGestorSimples';
      const nrorg = store.getters.user.nrorg;
      const nrestruturam = store.getters.estruturaGerencialAtual.NRESTRUTURAM;
      const nrperiodoapuracao = store.getters.periodoDemonstrativoAtual.NRPERIODOAPURACAO;

      const params = {
        requestType: 'FilterData',
        NRPERIODOAPURACAO: nrperiodoapuracao,
        NRESTRUTURAM: nrestruturam,
        NRORG: nrorg,
      };

      const response = await HttpRequest.get(route, params, false);
      const vinculos = response.data.dataset.data;

      await VinculoRepository.deleteVinculo();
      await VinculoRepository.setVinculos(vinculos);

    } catch(err) {

      if(this.isMobile) return;

      throw 'Não foi possível obter os vínculos para o uso offline.';
    }
  }

  private static async storeOffline() {
    const promises = await Promise.all([
      this.updateUserOffline(),
      this.updateEstruturasOffline(),
      this.updatePeriodoOffline()
    ]);
  }

  // Usuario
  private static async setUserOffline(userOffline: UserOffline) {
    try {
      if(this.isMobile) {
        await UserRepository.deleteUser();
        await UserRepository.setUser(userOffline);
      } 
    } catch (error) {
      
    }
  }

  private static async updateUserOffline() {

    const userData = await UserRepository.getUser();

    store.commit('updateUser', {
      name: userData.NMOPERADOR,
      id: userData.CDOPERADOR,
      email: null,
      team: null,
      shift: null,
      nrvinculom: userData.NRVINCULOM,
      nrtipovinculom: null,
      cdoperador: userData.CDOPERADOR,
      nmoperador: userData.NMOPERADOR,
      nrorg: userData.NRORG,
      dp: userData.ISDP == UtilPG.ID_TRUE,
      nrestrutlegal: null,
      nrestrutgeren: null,
      idalterptovinculo: null,
      idaprovocorrencia: null,
      idaltresumofreq: null,
      idtrocahorario: null,
      idconfirmrecsenport: null,
      idrealizaadmissao: null,
      idrealizacadautom: null,
      iddpalterptovinculo: null,
      nrparcnegocio: userData.NRPARCNEGOCIO,
      idpgrestringeregist: false,
      idbloqueioedicaomarc: null,
      idexigefotoregpntpg: userData.IDEXIGEFOTOREGPNTPG == UtilPG.ID_TRUE,
      idpgrestringetelaregist: userData.IDPGRESTRINGETELAREGIST == UtilPG.ID_TRUE,
      nrtpestrutlegal: null,
      nrtpestrutgeren: null,
      idativacontroleacesso: null,
      idoperadorsst: null,
    });
  }

  // Estruturas
  private static async setEstruturasOffline(estruturasOffline: EstruturasOffline[]) {
    if(this.isMobile) {
      await EstruturaRepository.deleteEstruturas();
      await EstruturaRepository.setEstruturas(estruturasOffline);
    }
  }

  private static async updateEstruturasOffline() {
    const estruturas = await EstruturaRepository.getEstruturas();
    store.commit('updateEstruturasGerenciais', estruturas);
  }

  // Periodo
  private static async setPeriodoOffline(periodoOffline: PeriodoOffline[]) {
    if(this.isMobile) {
      await PeriodoRepository.deletePeriodos();
      await PeriodoRepository.setPeriodos(periodoOffline);
    }
  }

  private static async updatePeriodoOffline() {
    const periodos = await PeriodoRepository.getPeriodos();
    store.commit('updatePeriodosDemonstrativo', periodos);
  }
}